import { DetectedWebView } from "@ciaopeople/cp-shatsu/ClientDetection/WebViewDetails.js";
import { IconName, getIconSVG } from "./IconSVG.js";
import { loadJS } from "@mp-commons/lib/utils/LoadJS.js";

export class ControlCast {

    private mainHtml: HTMLElement;
    private currentIcon: HTMLElement;

    constructor(wvDetected: DetectedWebView, css_prefix: string) {
        const bClass = `${css_prefix}-btn`;
        this.currentIcon = getIconSVG(IconName.cast);

        if (wvDetected.platform.ios || wvDetected.platform.macosx) {
            this.mainHtml = <div class={`${bClass} ${bClass}--${IconName.cast}`}>
                {this.currentIcon}
            </div>;
        } else {
            loadJS("https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1", window.document.head)

            this.mainHtml = <div class={`${bClass} ${bClass}--${IconName.cast} ${bClass}--gsdk`}>
                <google-cast-launcher id="castbutton"></google-cast-launcher>
            </div>;
        }
    }

    get html(): HTMLElement {
        return this.mainHtml;
    }

    private changeIcon(icon: IconName) {
        this.currentIcon.remove();
        const newIcon = getIconSVG(icon)
        this.mainHtml.appendChild(newIcon);
        this.currentIcon = newIcon;
    }

    updateStatus(enabled: boolean) {
        if (enabled) {
            this.mainHtml.classList.add("active");
            this.changeIcon(IconName.cast_on);
        } else {
            this.mainHtml.classList.remove("active");
            this.changeIcon(IconName.cast);
        }
    }

    onClick(listener: EventListener): void {
        this.mainHtml.addEventListener("click", listener);
    }

}